import "./Component4.css";
import { Link } from "react-router-dom";
import { useState } from "react";

const Component4 = ({ Data, addToCart, toggleWishlist }) => {
  const [cardModes, setCardModes] = useState({});

  // Initialize card modes on first render
  if (Object.keys(cardModes).length === 0 && Data.length > 0) {
    const initialModes = {};
    Data.forEach(item => {
      initialModes[item.id] = 'retail';
    });
    setCardModes(initialModes);
  }

  const handleModeChange = (itemId, mode) => {
    setCardModes(prev => ({
      ...prev,
      [itemId]: mode
    }));
  };

  return (
    <section id="Edit-section">
      <div className="container">
        <div className="pransh_name d-flex gap-2 ms-3">
          <span />
          <h6 className=" mt-1">This Month</h6>
        </div>
        <div className="row m-0 m-auto">
          <div className="col-8">
            <h2 className="mt-3 mb-3">Best Selling Product</h2>
          </div>
          <div className="col-4 viewAll text-end align-content-center">
            <Link type="buttom" to="#" className="py-2 px-3">
              view all
            </Link>
          </div>
        </div>
        <div className="row mt-1 mt-lg-1 mx-0 mx-lg-2" id="selling-component">
          {Data.map((item) => {
            const currentMode = cardModes[item.id] || 'retail';
            const displayPrice = currentMode === 'wholesale'
              ? (item.priceWholesale || item.price)
              : item.price;

            return (
              <div key={item.id} className="col-6 col-md-4 col-lg-3 m-0 m-auto my-3">
                <div className="card">
                  <div className="card-img-top">
                    <img src={item.img} alt="..." width="100%" />
                    <div className="add py-1 pb-2 text-center">
                      <span>
                        <Link to="#" onClick={(e) => { e.preventDefault(); addToCart(item, currentMode); }}>Buy Now</Link>
                      </span>
                    </div>
                    <div className="H_I_icons">
                      <ul className="list-unstyled text-center">
                        <li className="mb-2" onClick={() => toggleWishlist && toggleWishlist(item)}>
                          <i className={`bi ${item.isWishlisted ? "bi-heart-fill text-danger" : "bi-heart"} d-flex justify-content-center pt-2`} />
                        </li>
                        <li className="mt-1" onClick={() => addToCart(item, currentMode)}>
                          <i
                            className={`bi ${item.cardActive === "active"
                              ? "bi-bag-check-fill"
                              : "bi-bag-plus"
                              } d-flex justify-content-center pt-2`}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="card-body p-0 mt-3">
                    <h5 className="card-title">{item.title}</h5>

                    {/* Mode Toggle */}
                    <div className="mode-toggle mb-2 d-flex gap-2 justify-content-center">
                      <button
                        className={`btn btn-sm ${currentMode === 'retail' ? 'btn-danger' : 'btn-outline-danger'}`}
                        onClick={() => handleModeChange(item.id, 'retail')}
                        style={{ fontSize: '11px', padding: '4px 8px' }}
                      >
                        🛒 Retail
                      </button>
                      <button
                        className={`btn btn-sm ${currentMode === 'wholesale' ? 'btn-warning' : 'btn-outline-warning'}`}
                        onClick={() => handleModeChange(item.id, 'wholesale')}
                        style={{ fontSize: '11px', padding: '4px 8px' }}
                      >
                        📦 Wholesale
                      </button>
                    </div>

                    {/* Price Display */}
                    <div className="price-info mb-2">
                      <div className="d-flex flex-column align-items-center">
                        <span className={`fw-bold ${currentMode === 'retail' ? 'text-danger' : 'text-warning'}`}>
                          KSh {displayPrice}
                          {currentMode === 'retail' && (
                            <span className="text-decoration-line-through text-muted ms-2 small">
                              KSh {item.oldPrice}
                            </span>
                          )}
                        </span>
                        {currentMode === 'wholesale' && (
                          <small className="text-muted">Min Qty: {item.wholesaleMinQty || 1}</small>
                        )}
                      </div>
                    </div>

                    <div className="d-flex justify-content-center mb-2">
                      <button
                        className={`btn btn-sm w-75 ${currentMode === 'retail' ? 'btn-danger' : 'btn-warning'}`}
                        onClick={(e) => {
                          e.preventDefault();
                          addToCart(item, currentMode);
                        }}
                      >
                        <i className="bi bi-cart-plus me-1"></i> Add to Cart
                      </button>
                    </div>

                    <div className="card-text d-flex gap-1 justify-content-center">
                      <ul className="list-unstyled d-flex m-0">
                        <StarCollector reviewStar={item.reviewStar} />
                      </ul>
                      <span>({item.numperReview})</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

function StarCollector({ reviewStar }) {
  const number = parseFloat(reviewStar);
  const starList = [];
  const fullStars = Math.floor(number);
  const hasHalfStar = number % 1 >= 0.5;

  for (let i = 0; i < fullStars; i++) {
    starList.push("full");
  }

  if (hasHalfStar) {
    starList.push("half");
  }

  while (starList.length < 5) {
    starList.push("empty");
  }

  return (
    <>
      {starList.map((star, index) => (
        <li key={index}>
          <ion-icon
            name={
              star === "full"
                ? "star"
                : star === "half"
                  ? "star-half-outline"
                  : "star-outline"
            }
          />
        </li>
      ))}
    </>
  );
}

export default Component4;
